<template>
    <div>
      <div class="container" :class="currentScreenType">
        <div class="ts-app-capture--cont">
          <section class="ts-app-capture--cont_question">
            <transition name="fade" mode="out-in">
                <workflow-host :current-workflow="currentWorkflow"></workflow-host>
            </transition>
          </section>
        </div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue';

import WorkflowHost from '../../../components/workflow/WorkflowHost.vue';
import workflow from '../router/userinterestworkflow';

export default {
  components: { WorkflowHost },
  computed: {
    currentScreenType() {
      return this.$route.meta.type;
		},
    currentWorkflow() {
      return workflow;
    }
  }
};
</script>

<style lang="scss">

@import "../../../assets/scss/project/sga.scss";

</style>